import LoadingManager from '../../../FE/src/assets/javascripts/utils/LoadingManager.js';

export default class TeamDirectory {
  constructor() {
    this.moduleClass = '.gg-team-directory';
    this.$modules = $(this.moduleClass);
    this.ajaxUrl = window.AJAX_URL || '/wp-admin/admin-ajax.php';

    // Selectors
    this.selectors = {
      tab: '.gg-team-directory__tab',
      grid: '.gg-team-directory__grid',
      header: '.gg-team-directory__header',
      card: '.gg-team-directory__card',
      modalOverlay: '.gg-team-directory__modal-overlay',
      modal: '.gg-team-directory__modal',
      modalClose: '.js-modal-close',
      modalImage: '.js-modal-member-image',
      modalPosition: '.js-modal-member-position',
      modalName: '.js-modal-member-name',
      modalBio: '.js-modal-member-bio',
      modalEmail: '.js-modal-member-email',
      modalEmailWrapper: '.js-modal-email-wrapper',
      modalTel: '.js-modal-member-tel',
      modalTelWrapper: '.js-modal-tel-wrapper',
      modalLinkedin: '.js-modal-linkedin-wrapper',
      groupTitle: '.team-group-title',
      groupDescription: '.team-group-description',
      modalContact: '.gg-team-directory__modal-contact',
    };
  }

  bindEvents($el) {
    const $modalOverlay = $el.siblings(this.selectors.modalOverlay);

    // Tab filtering
    $el.find(this.selectors.tab).on('click', (e) => {
      this.handleTabClick($(e.currentTarget), $el);
    });

    // Modal open
    $el.on('click', this.selectors.card, (e) => {
      e.preventDefault();
      this.openModal($(e.currentTarget), $modalOverlay);
    });

    // Modal close - click on overlay
    $modalOverlay.on('click', (e) => {
      if ($(e.target).hasClass('gg-team-directory__modal-overlay')) {
        this.closeModal($modalOverlay);
      }
    });

    // Modal close - click on close button
    $modalOverlay.find(this.selectors.modalClose).on('click', (e) => {
      e.preventDefault();
      this.closeModal($modalOverlay);
    });

    // Prevent modal content click from closing
    $modalOverlay.find(this.selectors.modal).on('click', (e) => {
      e.stopPropagation();
    });
  }

  handleTabClick($tab, $el) {
    const teamGroupSlug = $tab.data('team-group');
    const termId = $tab.data('term-id');

    // Update URL with group parameter
    this.updateURLParameter('group', teamGroupSlug);

    // Load team members via AJAX
    this.loadTeamMembers(teamGroupSlug, termId, $el, $tab);
  }

  loadTeamMembers(teamGroupSlug, termId, $el, $tab) {
    const $grid = $el.find(this.selectors.grid);
    const $header = $el.find(this.selectors.header);

    // Show loading overlay
    LoadingManager.show();

    $.ajax({
      url: this.ajaxUrl,
      type: 'POST',
      data: {
        action: 'load_team_members',
        // eslint-disable-next-line camelcase
        team_group: teamGroupSlug,
        // eslint-disable-next-line camelcase
        term_id: termId,
      },
      success: (response) => {
        if (response.success) {
          // Update grid
          $grid.html(response.data.html);

          // Update header
          if (response.data.term_name) {
            $header
              .find(this.selectors.groupTitle)
              .text(response.data.term_name);
          }
          if (response.data.term_description) {
            $header
              .find(this.selectors.groupDescription)
              .html(response.data.term_description);
          } else {
            $header.find(this.selectors.groupDescription).html('');
          }

          // Update active state after successful load
          $el.find(this.selectors.tab).removeClass('active');
          $tab.addClass('active');

          // Reinitialize animations if needed
          if (typeof window.initAnimations === 'function') {
            window.initAnimations();
          }
        } else {
          $grid.html('<p>No team members found.</p>');
        }
      },
      error: () => {
        $grid.html('<p>Error loading team members. Please try again.</p>');
      },
      complete: () => {
        // Hide loading overlay
        LoadingManager.hide();
      },
    });
  }

  openModal($button, $modalOverlay) {
    // Get member data from card data attributes
    const $card = $button.closest(this.selectors.card);
    const data = {
      thumbnail: $card.data('member-thumbnail'),
      title: $card.data('member-name'),
      position: $card.data('member-position'),
      email: $card.data('member-email'),
      tel: $card.data('member-tel'),
      linkedin: $card.data('member-linkedin'),
      bio: $card.data('member-bio'),
    };

    // Populate modal
    $modalOverlay
      .find(this.selectors.modalImage)
      .attr('src', data.thumbnail || '')
      .attr('alt', data.title || '');
    $modalOverlay.find(this.selectors.modalPosition).text(data.position || '');
    $modalOverlay.find(this.selectors.modalName).text(data.title || '');
    $modalOverlay.find(this.selectors.modalBio).html(data.bio || '');
    if (!data.email && !data.tel && !data.linkedin) {
      $modalOverlay.find(this.selectors.modalContact).hide();
    } else {
      $modalOverlay.find(this.selectors.modalContact).show();
      // Email
      if (data.email) {
        $modalOverlay
          .find(this.selectors.modalEmail)
          .text(data.email)
          .attr('href', `mailto:${data.email}`);
        $modalOverlay.find(this.selectors.modalEmailWrapper).show();
      } else {
        $modalOverlay.find(this.selectors.modalEmailWrapper).hide();
      }

      // Tel
      if (data.tel) {
        $modalOverlay
          .find(this.selectors.modalTel)
          .text(data.tel)
          .attr('href', `tel:${data.tel}`);
        $modalOverlay.find(this.selectors.modalTelWrapper).show();
      } else {
        $modalOverlay.find(this.selectors.modalTelWrapper).hide();
      }

      // LinkedIn
      if (data.linkedin) {
        $modalOverlay
          .find(this.selectors.modalLinkedin)
          .show()
          .find('a')
          .attr('href', data.linkedin);
      } else {
        $modalOverlay.find(this.selectors.modalLinkedin).hide();
      }
    }

    // Show modal
    $modalOverlay.addClass('active');
    $('html').addClass('overflow-hidden');
  }

  closeModal($modalOverlay) {
    $modalOverlay.removeClass('active');
    $('html').removeClass('overflow-hidden');
  }

  updateURLParameter(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
  }

  init() {
    if (this.$modules.length) {
      this.$modules.each((_index, el) => {
        const $el = $(el);
        this.bindEvents($el);
      });
    }
  }
}

new TeamDirectory().init();
